<template>
  <div>
    <div class="container">
      <h3 class="page-title">Change Password</h3>

      <v-form ref="form">
        <v-text-field
          name="password"
          label="Current Password"
          v-model="currentPassword"
          :type="showCurrent ? 'text' : 'password'"
          :append-inner-icon="showCurrent ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showCurrent = !showCurrent"
          :rules="[rules.required]"
          variant="outlined"
          density="compact"
          autocomplete="current-password"
          required
          prepend-inner-icon="mdi-form-textbox-password"
          class="mb-2"
        />

        <v-text-field
          name="new-password"
          label="New Password"
          v-model="newPassword"
          :type="showNew ? 'text' : 'password'"
          :append-inner-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showNew = !showNew"
          :rules="[rules.required, rules.min8]"
          variant="outlined"
          density="compact"
          autocomplete="new-password"
          required
          prepend-inner-icon="mdi-form-textbox-password"
          class="mb-2"
        />

        <v-text-field
          name="confirm-new-password"
          label="Confirm New Password"
          v-model="confirmPassword"
          :type="showConfirm ? 'text' : 'password'"
          :append-inner-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append-inner="showConfirm = !showConfirm"
          :rules="[rules.required, rules.matchesNew]"
          variant="outlined"
          density="compact"
          autocomplete="new-password"
          required
          prepend-inner-icon="mdi-form-textbox-password"
          class="mb-2"
        />

        <div class="d-flex align-item-end justify-end px-3">
          <v-btn
            id="update-password"
            @click="updatePassword"
            variant="outlined"
            rounded="0"
            :loading="loading"
            :disabled="loading"
            style="height: 40px !important"
          >
            <v-icon start>mdi-content-save</v-icon>
            <span>Update Password</span>
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import cognitoAuth from '@/cognito'

const currentPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')

const showCurrent = ref(false)
const showNew = ref(false)
const showConfirm = ref(false)

const loading = ref(false)
const form = ref(null)

const store = useStore()

const rules = {
  required: v => (!!v || v === 0) || 'This field is required.',
  min8: v => (v?.length >= 8) || 'At least 8 characters.',
  matchesNew: v =>
    v === newPassword.value || 'Confirmation must match the new password.'
}

async function updatePassword () {
  const { valid } = await form.value.validate()
  if (!valid) return

  loading.value = true
  try {
    cognitoAuth.changePassword(currentPassword.value, newPassword.value, (err, result) => {
      if (err) {
        store.commit('snackbar/showMessage', {
          content: 'Incorrect password. Please try again.',
          color: 'red'
        }, { root: true })
      } else {
        store.commit('snackbar/showMessage', {
          content: 'Password updated successfully',
          color: 'blue'
        }, { root: true })
      }

      currentPassword.value = ''
      newPassword.value = ''
      confirmPassword.value = ''
      form.value.resetValidation()
    })
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.page-title {
  margin-bottom: 32px;
  font-size: 20px;
  font-weight: 700;
  color: var(--dark-4, #363A40);
}
</style>
